var selector = $('.gallery-img-wrapper .title-container')

selector.on('click',function(){
	selector.toggleClass('hidden-title')
})